class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* GOWin empty cart layout continuity — 2026-08-06 */
(() => {
  const STYLE_ID = 'gowin-empty-cart-layout-v2';

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      cart-drawer.is-empty .drawer__inner {
        display: flex !important;
        flex-direction: column !important;
        align-items: stretch !important;
        padding: 0 !important;
      }

      cart-drawer.is-empty .drawer__header {
        display: flex !important;
        order: -1 !important;
        flex: 0 0 auto !important;
        margin: 0 clamp(1.6rem, 2.5vw, 2.8rem) !important;
      }

      cart-drawer.is-empty .drawer__inner-empty {
        height: auto !important;
        min-height: 0 !important;
        flex: 1 1 auto !important;
        padding: 0 !important;
        overflow-y: auto !important;
      }

      cart-drawer.is-empty .cart-drawer__warnings {
        display: flex !important;
        flex: 0 0 auto !important;
        justify-content: flex-start !important;
        gap: 2rem !important;
        padding: 2.2rem clamp(1.6rem, 2.5vw, 2.8rem) 3rem !important;
      }

      cart-drawer.is-empty .cart-drawer__empty-content {
        order: 1 !important;
        margin: 0 auto !important;
      }

      cart-drawer.is-empty .cart-drawer__empty-content .drawer__close {
        display: none !important;
      }

      cart-drawer.is-empty .gowin-drawer-shipping {
        order: 2 !important;
        margin: 0 auto !important;
      }

      cart-drawer.is-empty .cart-drawer__collection {
        order: 3 !important;
      }

      @media screen and (max-width: 749px) {
        cart-drawer.is-empty .drawer__header {
          margin-inline: 1.6rem !important;
        }

        cart-drawer.is-empty .cart-drawer__warnings {
          gap: 1.6rem !important;
          padding: 1.8rem 1.6rem calc(2rem + env(safe-area-inset-bottom)) !important;
        }
      }
    `;

    document.head.appendChild(style);
  };

  ensureStyles();
  document.addEventListener('cart:updated', ensureStyles);
  document.addEventListener('shopify:section:load', ensureStyles);
})();
